import { battlesApi } from '@shared/api';
import { getViewerIdentity } from '@shared/lib/auth/viewer-identity';
import { BattleRoomStore } from './battle-room-store';
import { openBattleSocket } from '@shared/lib/battle-socket';

import { createActionId } from '@shared/lib/id/action-id';
import { readBattleAnswer, writeBattleAnswer } from '../lib/answer-cache';

const room = new BattleRoomStore(
  {
    ...battlesApi,
    open: openBattleSocket,
    actionId: createActionId,
    readAnswer: (code, key) => readBattleAnswer(getViewerIdentity()?.login ?? '', code, key),
    writeAnswer: (code, key, value) => writeBattleAnswer(getViewerIdentity()?.login ?? '', code, key, value),
  },
  () => getViewerIdentity()?.login,
);
export const getBattleRoom = () => room;
